<template>
  <div>
    <v-btn color="primary" @click="dialog = true">
      <v-icon left>mdi-plus</v-icon>
      novo
    </v-btn>

    <sys-dialog
      v-model="dialog"
      titulo="Filial X Famílias de Distribução"
      @click:hidden-dialog="resetDialog();verificaAtualizarFora()"
    >
      <div class="d-flex mt-2 mx-2">
        <v-col cols="2" class="pa-0">
          <sys-grupo-autocomplete
            v-model="item.grupo"
            label="Selecione o Grupo"
            outlined
            dense
            height="10"
          ></sys-grupo-autocomplete>
        </v-col>

        <v-col cols="3" class="pa-0">
          <sys-filial-grupo-autocomplete
            v-model="item.filiais"
            :id-grupo="item.grupo"
            label="Selecione as Filiais"
            outlined
            dense
            multiple
            height="10"
            class="pl-4"
            :qtde-visivel-selecionados="7"
            :disabled="item.grupo <= 0"
          ></sys-filial-grupo-autocomplete>
        </v-col>

        <v-col cols="3" class="pa-0">
          <v-autocomplete
            ref="categoriasDeDistribuicao"
            v-model="item.familiais"
            :items="listaDeFamiliais"
            item-value="familia"
            item-text="descricao"
            label="Selecione as Categorias de Distribuição"
            outlined
            dense
            multiple
            height="10"
            small-chips
            class="pl-4"
            :loading="loading"
            :disabled="!item.filiais || item.filiais.length === 0"
            @change="item.categorias = []"
          >
            <template v-slot:prepend-item>
              <v-list-item class="py-0 pl-2">
                <v-btn icon @click="$refs.categoriasDeDistribuicao.blur()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <span class="ml-3 caption-1">Categorias de Distribução das Filiais selecionadas</span>
              </v-list-item>

              <v-divider />

              <sys-item-lista-seleciona-tudo
                v-model="item.familiais"
                :itens="listaDeFamiliais"
                valor-chave="familia"
              ></sys-item-lista-seleciona-tudo>
            </template>

            <template v-slot:selection="{item: itemSelecionado}">
              <v-chip v-if="item.familiais.indexOf(itemSelecionado.familia) < 1" small>
                {{itemSelecionado.descricao}}
              </v-chip>

              <template v-if="item.familiais.indexOf(itemSelecionado.familia) === 1">
                <v-chip small class="txt-outros">{{ `+ ${item.familiais.length - 1}`}}</v-chip>
              </template>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="4" class="pa-0">
          <v-autocomplete
            ref="grupoCategoria"
            v-model="item.categorias"
            :items="gruposDasFamiliaisSelecionadas"
            item-value="idcategoria"
            item-text="descricao"
            label="Selecione os Grupos da Família"
            outlined
            dense
            multiple
            height="10"
            class="pl-4"
            :loading="loading"
            small-chips
            :disabled="!item.familiais || item.familiais.length === 0"
          >
            <template v-slot:prepend-item>
              <v-list-item class="py-0 pl-2">
                <v-btn icon @click="$refs.grupoCategoria.blur()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <span class="ml-3 caption-1">Grupos das Categorias Selecionadas</span>
              </v-list-item>

              <v-divider />

              <sys-item-lista-seleciona-tudo
                v-model="item.categorias"
                :itens="gruposDasFamiliaisSelecionadas"
                valor-chave="idcategoria"
              ></sys-item-lista-seleciona-tudo>
            </template>

            <template v-slot:selection="{item: itemSelecionado}">
              <v-chip v-if="item.categorias.indexOf(itemSelecionado.idcategoria) <= 1" small>
                {{itemSelecionado.descricao}}
              </v-chip>

              <template v-if="item.categorias.indexOf(itemSelecionado.idcategoria) === 2">
                <v-chip small class="txt-outros">{{ `+ ${item.categorias.length - 2}`}}</v-chip>
              </template>
            </template>
          </v-autocomplete>
        </v-col>
      </div>

      <mapeamento-categorias
        v-bind="item"
        :itens="subCategoriasFiltradas"
        class="mt-n1 px-2"
        @updateTableDialogClosed="refreshDataTableFora = $event"
      ></mapeamento-categorias>
    </sys-dialog>
  </div>
</template>

<script>
import SysDialog from "../../padraoDeLayout/SysDialogFullScreen"
import SysGrupoAutocomplete from "../../utils/crud/SysGrupoAutocomplete"
import SysFilialGrupoAutocomplete from "../../utils/crud/SysFilialGrupoAutocomplete"
import SegmentoAPI from "../../../api/segmento"
import SysItemListaSelecionaTudo from "../../utils/crud/SysItemListaSelecionaTudo";
import MapeamentoCategorias from "./MapeamentoDeCategoriaDeDistribuicao"

export default {
  name: "MapeaFamiliasDistribuicaoDialog",
  components: {SysItemListaSelecionaTudo, SysFilialGrupoAutocomplete, SysGrupoAutocomplete, SysDialog, MapeamentoCategorias},
  props: {
    itemSelecionado: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    dialog: false,
    loading: false,
    item: {grupo: "", filiais: [], familiais: [], categorias: []},
    listaDeCategorias: [],
    refreshDataTableFora: false
  }),
  computed: {
    listaDeFamiliais () {
      return this.listaDeCategorias.filter(item => !item.grupo)
    },
    gruposPorFamilia () {
      return this.listaDeCategorias.filter(item => `${item.idcategoria}` === `${item.grupo}`)
    },
    gruposDasFamiliaisSelecionadas () {
      if (this.item.familiais.length === 0) {
        return []
      }

      const FILTRO_FAMILIAIS = item => this.item.familiais.includes(item.familia)
      return this.gruposPorFamilia.filter(FILTRO_FAMILIAIS)
    },
    subCategoriasFiltradas () {
      if (this.item.categorias.length === 0) {
        return []
      }

      const FILTRO_GRUPOS = item => this.item.categorias.includes(item.grupo) //&& item.grupo !== item.idcategoria
      return this.listaDeCategorias.filter(FILTRO_GRUPOS)
    }
  },
  watch: {
    dialog (valorDialog) {
      if (valorDialog && !this.listaDeCategorias.length) {
        this.getCategoriasProduto()
      }
    },
    itemSelecionado (item) {
      if (!item.grupo) {
        return
      }

      this.item = {...item}
      this.dialog = true
    }
  },
  methods: {
    getCategoriasProduto () {
      this.loading = true
      const headers = this.Helpers.iniciarRequisicao()

      SegmentoAPI.getCategoriasProduto(headers)
        .then(response => {
          const {token, categorias} = response.data
          localStorage.token = token
          this.listaDeCategorias = categorias
          this.loading = false
        })
        .catch(() => this.Helpers.logout())
    },
    resetDialog () {
      this.item = {grupo: "", filiais: [], familiais: [], categorias: []}
      this.$emit('fecha:dialog', {})
    },
    verificaAtualizarFora() {
      if (this.refreshDataTableFora) {
        this.$emit("update:dataTable", {})
        this.refreshDataTableFora = !this.refreshDataTableFora
      }
    }
  }
}
</script>

<style scoped>
.caption-1 {
  font-size: 14px;
  font-weight: 500;
}
.txt-outros {
  color: #777777;
}
</style>
